module.exports = __webpack_public_path__ + "img/repleArrow.2593dec5.png";